<script>
  import { Navigation, Pagination, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import "carbon-components-svelte/css/g90.css";
  import {Button} from 'carbon-components-svelte';
  import Tailwindcss from '../Tailwind.svelte'
  import {animateScroll} from 'svelte-scrollto-element'
  import Verify from './Verify.svelte';
  import {Motion, M} from 'svelte-motion'
  import Details from './Details.svelte'
  import {geo} from '../userdata'
  import axios from 'axios'
  import PhoneOTP from './PhoneOTP.svelte'
  import {push} from 'svelte-spa-router'
  import {fade} from 'svelte/transition'
  import {sessionData} from '../stores.js'
  import {_} from 'svelte-i18n'
  import { onMount } from 'svelte';
  import UserDetails from './UserDetails.svelte';
  import {getAuth, signInWithPhoneNumber, RecaptchaVerifier} from 'firebase/auth'
  import {auth} from '../firebase.js'
  import {container, itemA, itemB, itemC} from './animations.js'

  import {signInWithGoogle, signInWithApple} from '../auth'

  // Global variable to toggle georestriction
  let disableGeorestriction = true;

  let swiper;
  let anchor
  let anchor_view
  let introAnimation = false
  let session
  let testval = false
  let recap
  let geores
  let phoneData

  sessionData.subscribe(value => {
    session = value
  })

  const gapi_url = process.env.BASE_GAMBIT_URL

  $: loginView = session.signin_flow == "login"
  $: detailsView = session.signin_flow == "details"
  $: termsView = session.signin_flow == "terms"
  $: phoneView = session.signin_flow == "details"
  $: verifyView = session.signin_flow == "verify"

  onMount(async () => {
    geores = geo()
  })

  function phoneSignin() {
    if ($sessionData.serverError) return;
    sessionData.update(s => ({...s, signin_flow : "phone"}))
  }

  function googleSignin() {
    if ($sessionData.serverError) return;
    signInWithGoogle()
  }

  function appleSignin() {
    if ($sessionData.serverError) return;
    signInWithApple()
  }

  function getDetails(){
    setTimeout (() => {
      sessionData.update(s => ({...s, signin_flow : "details"}))
    },100)
  }
</script>

<Tailwindcss/>


{#await geores}
  <div  class:non-interactable={!$sessionData.hasGeolocated} class:interactable={$sessionData.hasGeolocated} bind:this={anchor_view} id="anchor-container"  class=" overflow-scroll hidescroll font-brown block w-1/2 p-24 bg-space select-none">
  </div>

{:then gres}
  {#if gres || disableGeorestriction}

  <div class:non-interactable={!$sessionData.hasGeolocated} class:interactable={$sessionData.hasGeolocated}  bind:this={anchor_view} id="anchor-container"  class=" overflow-scroll hidescroll font-brown block w-1/2 p-24 bg-space select-none">
    {#key session.signin_flow}
    {#if loginView}

  <div out:fade>
    <M.div initial="hidden" variants={container} animate="show" class="flex flex-col gap-y-10">
      <M.img variants={itemC} class="-translate-x-6 w-24 h-24" src="glogo.png" alt=""/>
      <M.h1 variants={itemC} class="text-6xl font-brown">{$_('signUp.login')}</M.h1>

      <M.button onTap={googleSignin} variants={itemC} class="gap-x-3 items-center rounded w-80 flex flex-row p-2 bg-white ">
        <img variants={itemC} class="h-10 right-0" src="googlelogo.png" alt="">
        <span class="text-xl inline-block align-middle text-black">{$_('common.continueWithGoogle')}</span>
      </M.button>

      <M.div onTap={appleSignin} variants={itemC} class="cursor-pointer gap-x-3 items-center rounded w-80 flex flex-row p-2 bg-white">
        <img class="h-10 right-0" src="applelogo.png" alt="">
        <span class="text-xl inline-block align-middle text-black">{$_('common.continueWithApple')}</span>
      </M.div>

      <M.img class="w-80" variants={itemC}  src="divider.svg" alt=""/>
      <button class="w-80" on:click={phoneSignin}>

        <M.div class="w-80 gap-x-3 flex flex-row content-center" variants={itemC} alt="">
          <img class="w-8" src="cellphone.svg" alt="cellphone.svg">
          <span class="text-xl text-left text-white">{$_('signUp.continueWithPhone')}</span>
        </M.div>
      </button>
      <M.p variants={itemC} class="whitespace-pre-line font-brown">
        {$_('common.disclaimer')}<a href="/#/terms" target="_blank" class="cursor-pointer text-white underline">{$_('common.termsOfService')}</a> {$_('common.and')} <a target="_blank" href="/#/privacy" class="text-white underline cursor-pointer">{$_('common.privacyPolicy')}</a>
      </M.p>

      {#if $sessionData.serverError}
        <M.h1 class="text-red-500 font-brown text-2xl" variants={itemC}>{$_('common.error')} <br> {$_('common.checkBackLater')}</M.h1>
      {/if}

    </M.div>
  </div>
{/if}

{#if $sessionData.signin_flow == 'details'}
  <UserDetails {container} variants={itemC} animate="show" />
{:else if $sessionData.signin_flow == 'terms' }
  <Details  {container} variants={itemC} animate="show" />
{:else if $sessionData.signin_flow == 'phone'}
  <PhoneOTP {container} variants={itemC} {phoneData} animate="show" />
{:else if $sessionData.signin_flow == 'verify'}
  <Verify {container} variants={itemC} {phoneData} animate="show" />
{/if}

{/key}

  </div>
{:else}

  <div class:non-interactable={!$sessionData.hasGeolocated} class:interactable={$sessionData.hasGeolocated} class="overflow-scroll hidescroll">
    <M.div initial="hidden" variants={container} animate="show" class="grid p-24 font-brown">
      <M.h1 class="pb-4" variants={itemC}>Oops! You've Hit a Geofence 🌐</M.h1>
      <M.p variants={itemC}>We're sorry, but it looks like you've landed on this page because access to our site has been restricted in your region. This is due to geofencing, a technology we use to control access to our content and services based on your geographical location.</M.p>
      <M.p class="pb-8" variants={itemC}>While we would love to welcome you with open arms, we must adhere to the rules and regulations set forth by certain countries and jurisdictions. This means that, unfortunately, our content and services are not available in your area at this time.</M.p>
      <M.h2 variants={itemC}>What can you do?</M.h2>
      <M.ol variants={itemC}>
        <M.li class="my-4 leading-5" variants={itemC}><strong>Double-check your location:</strong> It's possible that our system has made an error in determining your location. If you believe this is the case, please let us know by contacting our support team at support@gambit.ai, and we'll investigate the issue.</M.li>
        <M.li class="my-4 leading-5" variants={itemC}><strong>Keep an eye on changes:</strong> We're continuously working to expand our offerings and reach more users worldwide. If our content becomes available in your region, we'll be sure to update our geofencing settings. You can stay informed by following our social media channels or signing up for our newsletter.</M.li>
        <M.li class="my-4 leading-5" variants={itemC}><strong>Stay engaged with us:</strong> Even if you can't access our main site, you can still connect with us through our social media profiles on platforms such as <a href="https://www.twitch.tv/gambitapp">Twitch</a>, <a href="https://www.tiktok.com/@gambitapp">TikTok</a>, <a href="https://www.instagram.com/gambit_app/">Instagram</a>, and <a href="https://www.facebook.com/gambitai">Facebook</a>. We'd love to have you as part of our community!</M.li>
      </M.ol>
      <M.p class="pb-4" variants={itemC}>We apologize for any inconvenience this may cause and appreciate your understanding. We hope that in the future, we can offer our site's content and services to you without restrictions.</M.p>
      <M.p variants={itemC}>Best regards,</M.p>
      <M.p variants={itemC}>Gambit</M.p>
    </M.div>
  </div>
{/if}

  {/await}

<style>
  .interactable {
    pointer-events: auto;
    opacity: 1;
  }

  .non-interactable {
    pointer-events: none;
    opacity: 0.5;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .hidescroll::-webkit-scrollbar {
    display: none;
  }
</style>
